import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { AICommentAssistantMenuComponent } from './ai-comment-assistant-menu.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { MarkerModule } from '@go-modules/components/marker/marker.module';
import { FormatTimeModule } from '@go-modules/pipes/format-time/format-time.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		MarkerModule,
		FormatTimeModule,
		A11yModule
	],
	declarations: [
		AICommentAssistantMenuComponent
	],
	exports: [
		AICommentAssistantMenuComponent
	]
})
export class AICommentAssistantMenuModule {}
